export default "__VITE_ASSET__Ctip9hpy__"